import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';
import { Logger } from './AnalyticsInterface';
import { isClientSide, VerboseLoggingOn } from './AnalyticsUtil';
import { getClientConfig } from '../Config/ClientConfig';

const ddClientToken = 'pub43208f2270b33916e4062c788395dc09';
const ddSite = 'datadoghq.com';

export const DataDogLogger: Logger = {
  name: 'DataDog',
  init: async () => {
    const { env, appVersion } = await getClientConfig();

    try {
      if (!datadogLogs.getInitConfiguration()) {
        datadogLogs.init({
          clientToken: ddClientToken,
          site: ddSite,
          forwardErrorsToLogs: true,
          forwardConsoleLogs: 'all',
          forwardReports: 'all',
          sampleRate: 100,
          telemetrySampleRate: 100,
          env: env,
          version: appVersion,
          service: 'kol-digital-refresh',
          trackLongTasks: true,
          trackResources: true,
        });
      }
    } catch (e) {
      if (VerboseLoggingOn) console.log(e);
    }

    datadogRum.init({
      env,
      applicationId: '649d4afa-508c-4b43-8992-f47da5019ba9',
      clientToken: ddClientToken,
      site: ddSite,
      service: 'kol-digital-refresh',
      version: appVersion,
      sessionSampleRate: 100,
      trackInteractions: true,
      trackFrustrations: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: 'mask',
      silentMultipleInit: true,
      trackSessionAcrossSubdomains: true,
      allowedTracingUrls: [
        'https://kol-three.vercel.app/',
        /https:\/\/.*karius-cx.vercel.*/,
        /https:\/\/.*\.kariusdx\.com/,
        /https:\/\/online\..*/,
      ],
    });

    datadogRum.startSessionReplayRecording();
  },

  identify: (superProps) => {
    datadogRum.setUser(superProps);
    datadogLogs.setLoggerGlobalContext(superProps);
  },
  logEvent: (name, props) => {
    datadogRum.addAction(name, props);

    if (isClientSide()) {
      datadogLogs.logger.log(name, props);
    }
  },
  logWarn: (name, props) => {
    if (isClientSide()) {
      datadogLogs.logger.warn(name, props);
    }
  },
  logError: (name, props) => {
    if (isClientSide()) {
      datadogLogs.logger.error(name, props);
    }
  },
};
